import { createReducer, on } from '@ngrx/store';
import * as manualServicesActions from '../actions/manual-services.actions';
import { ManualServiceState } from '../../models/manual-service.models';


export const initialOrdersState: ManualServiceState = {
  data: null,
  manualOrders: [],
  manualOrder: null,
  isLoading: false,
  error: null,
  totalItems: null,
  totalPages: null,
  vehicleTypes: [],
   calculatedOrderRoute: null,
  
};

export const manualServicesReducer = createReducer(
initialOrdersState,
    on(
      manualServicesActions.loadManualServices, (state) => ({
        ...state,
        isLoading: true,
      })),
    on(
      manualServicesActions.loadManualServicesSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        manualOrders: action.orders.items,
        totalItems: action.orders.total_items,
        totalPages: action.orders.total_pages,
      })),
    on(
      manualServicesActions.loadManualServicesFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error,
      })),
    on(manualServicesActions.createManualOrder, (state) => ({
            ...state,
            isLoading: true,
        })),
    on(manualServicesActions.createManualOrderSuccess, (state, action) => ({
        ...state,
        manualOrders: [...state.manualOrders, action.manualOrder],
        isLoading: false,
    })),
    on(manualServicesActions.createManualOrderFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
        on(manualServicesActions.updateManualOrder, (state, action) => ({
        ...state,
        manualOrder: action.manualOrder,

    })),
      on(manualServicesActions.calculateManualOrderRoute, (state) => ({
            ...state,
            isLoading: true,
        })),
    on(manualServicesActions.calculateManualOrderRouteSuccess, (state, action) => ({
        ...state,
        calculatedOrderRoute: action.calculatedOrderRoute,
        isLoading: false,
    })),
    on(manualServicesActions.calculateManualOrderRouteFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(manualServicesActions.loadVehicleTypes, (state) => ({
          ...state,
          
      })),
    on(manualServicesActions.loadVehicleTypesSuccess, (state, action) => ({
        ...state,
        vehicleTypes: action.vehicleTypes,
        
    })),
    on(manualServicesActions.loadVehicleTypesFailure, (state, action) => ({
        ...state,
        error: action.error,
      
    })),
    on(manualServicesActions.cancelOrder, (state) => ({
            ...state,
            isLoading: true,
        })),
    on(manualServicesActions.cancelOrderSuccess, (state, action) => ({
        ...state,
        // orders: state.orders.filter(order => order.id == action.order.id),
        isLoading: false,
    })),
    on(manualServicesActions.cancelOrderFailure, (state, action) => ({
        ...state,   
        error: action.error,
        isLoading: false,
    })),
    on(manualServicesActions.editOrder, (state) => ({
            ...state,
            isLoading: true,
        })),
    on(manualServicesActions.editOrderSuccess, (state, action) => ({
            ...state,
            manualOrder: action.manualOrder,
            isLoading: false,
    })),
    on(manualServicesActions.editOrderFailure, (state, action) => ({
            ...state,
            error: action.error,
            isLoading: false,
        })) 
);